module.exports = __webpack_public_path__ + "static/media/dataScience400x200.6375bdcb.jpg";